/* MoreActionsCTA.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"],
  _excluded3 = ["triggerRef"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _5 = "._syaz131l{color:var(--ds-text-subtlest,#626f86)}";
const _4 = "._19pkv77o{margin-top:var(--ds-space-025,2px)}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import Badge from '@atlaskit/badge';
import { IconButton } from '@atlaskit/button/new';
import DropdownMenu, { DropdownItem, DropdownItemGroup } from '@atlaskit/dropdown-menu';
import { AutoDismissFlag, FlagGroup } from '@atlaskit/flag';
import CheckCircleIcon from '@atlaskit/icon/glyph/check-circle';
import MoreIcon from '@atlaskit/icon/glyph/more';
import { BodyNormal, FinePrint } from '@atlassian/mpac-primitives';
import React, { useState } from 'react';
import { useWatchApp } from '../WatchApp';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const _3 = "._jq8g8pqr button{height:2.5rem}";
const _2 = "._14hp8pqr button{width:2.5rem}";
const _ = "._18u0u2gc{margin-left:var(--ds-space-100,8px)}";
export const WatchAppTrigger = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "span",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_18u0u2gc _14hp8pqr _jq8g8pqr", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  WatchAppTrigger.displayName = 'WatchAppTrigger';
}
const WatchAppSubtext = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = FinePrint,
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_4, _5]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_19pkv77o _syaz131l", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  WatchAppSubtext.displayName = 'WatchAppSubtext';
}
export const MoreActionsCTA = _ref3 => {
  let {
    watchersInfo,
    appKey,
    isLoggedIn,
    loginHref
  } = _ref3;
  const {
    watchingStatus,
    watcherCount,
    handleStopWatching,
    handleStartWatching
  } = useWatchApp({
    appKey,
    initialWatchingStatus: (watchersInfo === null || watchersInfo === void 0 ? void 0 : watchersInfo.isUserWatchingApp) || false,
    initialWatcherCount: (watchersInfo === null || watchersInfo === void 0 ? void 0 : watchersInfo.watchersCount) || 0,
    userLoggedIn: Boolean(isLoggedIn),
    onWatchSuccess: () => {
      setFlagType('watch-success');
    },
    onUnwatchSuccess: () => {
      setFlagType('unwatch-success');
    }
  });
  const [flagType, setFlagType] = useState(null);
  function getFlagContent() {
    if (flagType === 'watch-success') {
      return {
        title: 'You are now watching this app',
        description: 'You will receive email updates whenever newer versions are released.'
      };
    }
    if (flagType === 'unwatch-success') {
      return {
        title: 'You are no longer watching this app',
        description: 'You will no longer receive email updates whenever newer versions are released.'
      };
    }
    return null;
  }
  const flagContent = getFlagContent();
  const onWatchClick = () => {
    if (!isLoggedIn) return;
    return watchingStatus ? handleStopWatching : handleStartWatching;
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(DropdownMenu, {
      placement: "bottom-end",
      trigger: _ref4 => {
        let {
            triggerRef
          } = _ref4,
          props = _objectWithoutProperties(_ref4, _excluded3);
        return /*#__PURE__*/_jsx(WatchAppTrigger, {
          children: /*#__PURE__*/_jsx(IconButton, _objectSpread(_objectSpread({
            spacing: "default",
            icon: MoreIcon,
            appearance: "default",
            label: "More actions"
          }, props), {}, {
            ref: triggerRef
          }))
        });
      },
      children: /*#__PURE__*/_jsx(DropdownItemGroup, {
        children: /*#__PURE__*/_jsxs(DropdownItem, {
          href: !isLoggedIn ? loginHref : undefined,
          onClick: onWatchClick(),
          children: [/*#__PURE__*/_jsxs(BodyNormal, {
            children: [watchingStatus ? 'Unwatch App' : 'Watch App', ' ', /*#__PURE__*/_jsx(Badge, {
              max: false,
              children: watcherCount
            })]
          }), /*#__PURE__*/_jsx(WatchAppSubtext, {
            children: watchingStatus ? 'Cancel email alerts for new version releases.' : 'Get email alerts for new version releases.'
          })]
        })
      })
    }), /*#__PURE__*/_jsx(FlagGroup, {
      children: flagType && /*#__PURE__*/_jsx(AutoDismissFlag, {
        onDismissed: () => setFlagType(null),
        icon: /*#__PURE__*/_jsx(CheckCircleIcon, {
          primaryColor: "var(--ds-icon-success, #22A06B)",
          label: "Success"
        }),
        description: flagContent === null || flagContent === void 0 ? void 0 : flagContent.description,
        id: "watch-unwatch-success-flag",
        title: flagContent === null || flagContent === void 0 ? void 0 : flagContent.title
      }, "watch-unwatch-success-flag")
    })]
  });
};